<template>
  <div>
    <div v-for="(val, key) in categories" :key="key">
      <div class="layout CONTENTS" v-if="val && val !== 'NaN'">
        <label class="LABEL layout-item is-5 text-md">
          {{displayLabel[key]}}
        </label>
        <div class="layout-item d-flex is-5 m-r-20">
          <responsive-rating-bars :value="val" starSize="23px" :isMainHeader="isMainHeader"/>
          <span
              class="text-md m-l-1"
              selenium="detailed_rating">
            {{ getNearestRoundedHalf(val) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { REVIEW_LABELS } from '@/constants/reviews';
import ResponsiveRatingBars from '@/components/RatingBars/ResponsiveRatingBars';

export default {
  REVIEW_LABELS,
  name: 'review-categories',
  components: {
    ResponsiveRatingBars,
  },
  props: {
    categories: {
      type: Object,
      required: true,
    },
    isMainHeader: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    displayLabel () {
      return {
        knowledge: 'Professionalism',
        responsiveness: 'Communication',
        quality_of_work: 'Quality of work',
        knowledge_average_rating: 'Professionalism',
        responsiveness_average_rating: 'Communication',
        quality_of_work_average_rating: 'Quality of work',
      };
    },
  },
  methods: {
    getNearestRoundedHalf (val) {
      return (Math.ceil(val * 2) / 2).toFixed(1);
    },
  },
};
</script>

<style lang="scss" scoped>
  .CONTENTS {
    .LABEL {
      padding-top: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

</style>
